<template>
  <Layout>
    <v-row justify="center" class="my-2">
      <h3>ประวัติการบันทึกข้อมูลทั้งหมด</h3>
    </v-row>
    <template v-if="loading">
      <v-skeleton-loader
        v-bind="attrs"
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn elevation="2" @click="goBack"> ย้อนกลับ </v-btn>
        </v-col>
      </v-row>
      <br />
      <v-row>
        <v-col>
          <template v-if="storeDetailLog">
            <TableStoreDetailLog
              v-if="storeDetailLog"
              :data="storeDetailLog"
            />
          </template>
          <template v-else>
            <v-row justify="center"> - ไม่พบข้อมูล -</v-row>
          </template>
        </v-col>
      </v-row>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import TableStoreDetailLog from '@/components/TableStoreDetailLog'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      storeDetailLog: (state) => state.job?.storeDetailLog ?? [],
      storeDetailLogLoading: (state) => state.job.isLoading,
    }),
    loading() {
      return this.storeDetailLogLoading
    },
  },

  components: {
    TableStoreDetailLog,
    Layout,
  },

  data() {
    return {}
  },

  async mounted() {
    const payload = {
      id: this.$route.params.id,
      storeId: this.$route.params.storeId,
      sku: this.$route.params.sku,
    }
    await this.$store.dispatch('job/getStoreDetailLog', payload)
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'StoreDetail',
        params: {
          id: this.$route.params.id,
          storeId: this.$route.params.storeId,
        },
      })
    },
  },
}
</script>
